export function hasSecurityIssues(input: string): boolean {
  const sqlKeywords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE', 'DROP', 'ALTER', 'CREATE'];
  const forbiddenChars = ['\0', '\n', '\r', '\b', '\t', '\x1a', "'", '"', '\\', '\'', '\"', '\*', '\/', '\_', '*', '/', '_'];

  const scriptPatterns = [/\<(\/?script)\>/i, /on\w+=/i, /javascript:/i];

  for (const keyword of sqlKeywords) {
    if (input.toUpperCase().includes(keyword)) {
      return true;
    }
  }

  for (const char of forbiddenChars) {
    if (input.includes(char)) {
      return true;
    }
  }

  for (const pattern of scriptPatterns) {
    if (pattern.test(input)) {
      return true;
    }
  }

  return false;
}